if (!customElements.get('collection-description')) {
  customElements.define(
    'collection-description',
    class CollectionDescription extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.description = this.querySelector('.collection-hero__description');
        // this.updateOverflowing(this.description);
        if (!this.description) return;

        this.updateOverflowing(this.description);
        this.observer = new ResizeObserver((entries) => {
          for (const entry of entries) {
            this.updateOverflowing(entry.target)
          }
        });
        this.observer.observe(this.description);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      updateOverflowing(el) {
        console.log({
          scrollHeight: el.scrollHeight,
          clientHeight: el.clientHeight,
          scrollWidth: el.scrollWidth,
          clientWidth: el.clientWidth,
        })
        this.classList.toggle(
          'collection-hero__description-wrapper--overflowing',
          el.scrollHeight > el.clientHeight || el.scrollWidth > el.clientWidth
        );
      }
    }
  );
}
